var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2215 20.5H2.77852C0.493042 20.5 -0.811553 18.2011 0.559732 16.5901C1.1668 15.877 1.54092 15.0311 1.6416 14.1441L2.20058 9.21898C2.50199 6.56329 4.48457 4.38399 7.16257 3.46708V3.33743C7.16257 1.77036 8.43293 0.5 10 0.5C11.5671 0.5 12.8374 1.77036 12.8374 3.33743V3.46708C15.5154 4.38399 17.498 6.56329 17.7994 9.21898L18.3584 14.1441C18.4591 15.0311 18.8332 15.877 19.4403 16.5901C20.8116 18.2011 19.507 20.5 17.2215 20.5ZM13.7151 23.0894C13.1434 24.499 11.6957 25.5 10 25.5C8.30433 25.5 6.85657 24.499 6.28486 23.0894C6.26103 23.0306 6.25 22.9675 6.25 22.9041C6.25 22.6119 6.48689 22.375 6.77911 22.375H13.2209C13.5131 22.375 13.75 22.6119 13.75 22.9041C13.75 22.9675 13.739 23.0306 13.7151 23.0894Z",
    fill: "#FBC926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b48cef710b2652019abcf158be78128f.svg";
export { ForwardRef as ReactComponent };